import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';

import { CustomAlert, CustomButton } from '../../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../../shared/Helpers/functions';
import { Trash } from '../../../../../shared/Assets/svgIcons';

import { DispatchProperties } from '../../../../../redux/store';
import { deleteBehavior, getBehaviors } from '../../../../../redux/State/clientSlice/behaviorReductionSlice';
import { DeleteClientBehaviorsProperties } from '../../../../../redux/API/ClientAPIHelpers/behaviorReductionProperties';
import { RED } from '../../../../../shared/Helpers/colors';
import { useScreenWidth } from '../../../../../shared/Helpers/hooks';

const DeleteContent = ({ data, onClose }: { data: DeleteClientBehaviorsProperties; onClose: () => void }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const [params] = useSearchParams();

	const deleteHandler = () => {
		const includeArchived = params.get('includeArchivedBehavior') === 'true';
		const funderId = params.get('behaviorFunderId') || null;
		const clientId = data.clientId;
		dispatch(deleteBehavior(data))
			.then(unwrapResult)
			.then(() => {
				dispatch(getBehaviors({ clientId, includeArchived, funderId }));
				onClose();
			})
			.catch(errorNormalizer);
	};

	return (
		<>
			<CustomButton title="Yes" onClick={deleteHandler} className="marginBottom16" />
			<CustomButton title="Cancel" buttonType="secondaryGray" onClick={onClose} />
		</>
	);
};

const DeleteBehavior = ({ data, onlyIcon }: { data: DeleteClientBehaviorsProperties; onlyIcon?: boolean }) => {
	const [open, setOpen] = useState<boolean>(false);
	const closeHandler = () => setOpen(false);

	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	return (
		<>
			<CustomButton
				title={onlyIcon || isMobile ? '' : 'Remove'}
				buttonType="secondaryGray"
				onClick={() => setOpen(true)}
				startIcon={<Trash />}
				style={{ backgroundColor: RED.QUATERNARY, color: RED.BASE }}
			/>
			<CustomAlert
				title="Are you sure you want to delete?"
				open={open}
				onClose={closeHandler}
				Content={() => <DeleteContent data={data} onClose={closeHandler} />}
			/>
		</>
	);
};

export default DeleteBehavior;
